import { isValidWebsite } from "utils/validator";

import { FieldError } from "../../error";
import { Field } from "../../field";
import { FieldSet } from "../../fieldset";
import { Merchant } from "../../merchant";
import { MerchantField } from "../../types";
import { maxLength } from "../../validate";

export class WebsiteField extends Field<string> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(
      model,
      {
        dataType: "string",
        testValue: "www.bestStore.com",
        propertyName: "website",
        applicable: true,
        uiFieldType: "Input",
        uiInputBaseProps: {
          inputMode: "url",
          autoCapitalize: "off",
        },
        ...opts,
      },
      fieldSet
    );
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }

  _validate(): void {
    const salesChannel = this._model.storeDetails.salesChannel.value;

    const value = this.value ?? "";
    if (!maxLength(255)(value ?? "")) {
      throw new FieldError(this, `Max length 255`, "InvalidLength");
    }

    if (salesChannel === "In-store Only") {
      if (!value.length) {
        throw new FieldError(this, `Value Required`, "Required");
      }
    }

    if (!isValidWebsite(value)) {
      throw new FieldError(this, `Must be a valid website`, "InvalidWebsite");
    }
  }
}
